export const getLatestRecord = <
  T extends { timestamp: string; coc_id: number }
>(
  records: T[] | undefined
): T | null => {
  if (!records || records.length === 0) return null;
  // Timestamps are second-precision and move flows write multiple records in
  // the same second, so tie-break on coc_id to get the newest insert.
  return [...records].sort(
    (a, b) =>
      new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime() ||
      b.coc_id - a.coc_id
  )[0];
};
